import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Button, TextField, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import LinkIcon from "@mui/icons-material/Link";
import { PASTEL } from "./livechatTheme";

// Pengganti window.prompt untuk FR-K-05 (generate link lanjut chat) — dialog dengan
// field readonly + tombol salin ke clipboard, konsisten dengan tema Pastel Bouquet.
export default function GenerateLinkDialog({ open, url, onClose }) {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(url || "");
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {
            // Clipboard API bisa gagal (mis. bukan secure context) — user tetap bisa salin manual dari field.
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <LinkIcon sx={{ color: PASTEL.primary }} fontSize="small" />
                    <Typography variant="subtitle1" fontWeight={700}>Link Lanjut Chat</Typography>
                </Stack>
                <IconButton onClick={onClose} size="small"><CloseIcon fontSize="small" /></IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                    Salin & kirim link ini ke pelanggan lewat WhatsApp supaya percakapan bisa dilanjutkan dari perangkat mana pun.
                </Typography>
                <TextField
                    fullWidth
                    size="small"
                    value={url || ""}
                    onFocus={(e) => e.target.select()}
                    InputProps={{
                        readOnly: true,
                        sx: { fontSize: 13, backgroundColor: PASTEL.surfaceAlt },
                    }}
                />
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={onClose} sx={{ textTransform: "none" }}>Tutup</Button>
                <Button
                    variant="contained"
                    startIcon={copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
                    onClick={handleCopy}
                    sx={{
                        textTransform: "none",
                        backgroundColor: PASTEL.primary,
                        "&:hover": { backgroundColor: PASTEL.primaryDark },
                    }}
                >
                    {copied ? "Tersalin" : "Salin Link"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
